module.exports = __webpack_public_path__ + "static/img/20250324183410.a3e3f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20250324183410.png
// module id = K6ww
// module chunks = 1